import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=f56bfb4c&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=f56bfb4c&prod&scoped=true&lang=scss"
import style1 from "./Register.vue?vue&type=style&index=1&id=f56bfb4c&prod&scoped=true&lang=css"
import style2 from "@/assets/css/contents02.css?vue&type=style&index=2&id=f56bfb4c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56bfb4c",
  null
  
)

export default component.exports